import { RouteActionType } from '../context/actions';
import { useRouteContext } from '../context/context';

export const useStartStop = () => {
  const { routeDispatch, routeState } = useRouteContext();

  const setReportDate = (stopId: string) => {
    routeDispatch({
      type: RouteActionType.SET_REPORT_START,
      payload: { date: new Date(), stopId: stopId },
    });
  };

  const clearReportDate = () => {
    routeDispatch({
      type: RouteActionType.SET_REPORT_START,
      payload: { date: undefined, stopId: undefined },
    });
  };

  return {
    timeInStop: routeState.reportStart
      ? Math.floor((new Date().getTime() - routeState.reportStart.getTime()) / 1000)
      : undefined,
    startedStopId: routeState.startedReportStop,
    setReportDate,
    clearReportDate,
  };
};
